<template>
<van-overlay :show="showMini">
    <div class="wrapper">
        <div class="content">
            <div class="title">温馨提示</div>
            <div class="message">{{message}}</div>
            <div class="qr-code-box" >
                <div class="qr-code-content">
                    <img class="qr-code" :src="minImg" />
                </div>
                
            </div>
        </div>
        <img src="@/assets/icon/close_img.png" class="close-img" @click="cancel">
    </div>
</van-overlay>
</template>
<script>
import http from "@/utils/http";
import api from "@/utils/api";

export default {
   name: 'MiniDialog',
   props:{
       showMini:{
           type: Boolean,
           default: false
       },
       message:{
           type: String,
           default:''
       },
       cid:{
           type: String,
           default:''
       }
   },
   data:()=>{
       return {
           minImg:''
       }
   },
   created() {
       this.initMinImg()
   },
   methods: {
       cancel() {
           this.$emit('close')
       },
       initMinImg() {
            let param = {
                cid: this.cid,
                source: "h5",
            };
            http.get(api.checkin.getQr, param).then((res) => {
                console.log(res)
                this.minImg = res.data.url;
            });
        },
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.content {
    width: rem(640);
    background-color: #fff;
    border-radius: rem(8);
}
.title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: rem(80);
    font-size: rem(30);
    color: #333;
}
.message {
    text-align: center;
    font-size: rem(28);
    color: #666;
    padding: rem(10);
}

.qr-code-box {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.qr-code-content {
    width: rem(600);
    height: rem(600);
    background-color: #fff;
    border-radius: rem(20);
}
.qr-code {
    width: 100%;
    height: 100%;
}
.close-img {
    height: rem(48);
    width: rem(48);
    margin-top: rem(30);
}
</style>


// WEBPACK FOOTER //
// src/components/MiniDialog.vue